import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CardDropdown from 'components/common/CardDropdown';
import FalconCardHeader from 'components/common/FalconCardHeader';
import React, { useEffect, useState } from 'react';
import { Badge, Card, Col, Row } from 'react-bootstrap';
import CagegorywiseSummaryPieChart from './CagegorywiseSummaryPieChart';
import { getDashboard_supportServicesTable_Line } from 'functions/dashboard';
import { colorCodes } from 'constants/color';
import SummaryPieChartAsset from './CagegorywiseSummaryPieChart';
import moment from 'moment';



const SummaryPieAsset = ({fromDate, toDate, companyId}) => {
  
  
  
  

  useEffect(()=>{
    loadTableData(fromDate, toDate);

    }
    ,[fromDate, toDate, companyId])
    
    const [tableData, setTableData] = useState([]);

    const loadTableData = async (fromDate, toDate) => {
      try {
        const data = {
          fromDate,
          toDate,
          type: 'asset'
        , companyId: companyId ? companyId : null
  };

        const token = localStorage.getItem('token');
        const tableDataO = await getDashboard_supportServicesTable_Line(
          data,
          token
        );
        // console.log(' CagegorywiseSummaryPieCategory ',tableDataO);

        const pieData = [
          // { value: 200, name: 'Attendance Management', itemStyle: { color: '#6ED2E3' } },
          // { value: 100, name: 'Leave', itemStyle: { color: '#83D897' } },
          // { value: 80, name: 'Dashboard', itemStyle: { color: '#FCCB8E' } },
          // { value: 160, name: 'Enterprise', itemStyle: { color: '#B0A8E2' } },
          // { value: 120, name: 'PMS', itemStyle: { color: '#A7E0C5' } },
          // { value: 90, name: 'Report Portal', itemStyle: { color: '#F3A5B0' } },
          // { value: 150, name: 'Salary', itemStyle: { color: '#E79EF0' } },
          // { value: 80, name: 'SSP', itemStyle: { color: '#FFDAC1' } },
          // { value: 110, name: 'Sync', itemStyle: { color: '#ABF7B5' } },
          // { value: 200, name: 'System Security & Admin', itemStyle: { color: '#9AD7E7' } },
          // { value: 100, name: 'Total System', itemStyle: { color: '#FFB1B3' } },
          // { value: 120, name: 'Manage Employee', itemStyle: { color: '#A7C5EB' } },
          // { value: 90, name: 'Other', itemStyle: { color: '#FFCE75' } },
          // { value: 180, name: 'Mobile App', itemStyle: { color: '#B9E9D6' } },
          // { value: 110, name: 'Work Flow Hierarchy', itemStyle: { color: '#F9B3C4' } },
        ];

  
        if (tableDataO.recordsets) {
          for (let i = 0; i < tableDataO.recordsets.length; i++) {
            pieData.push({
              name:tableDataO.recordsets[i][0].groupby,
              value: tableDataO.recordsets[i][0].totalTickets,
              legendData:tableDataO.recordsets[i][0].groupby,
              itemStyle: { color: colorCodes[i] }
            });
          }
        }

        setTableData(pieData);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    
    
    
    


  return (
    <Card className="card h-100">
      <FalconCardHeader
          title={`Asset-wise Summary (%) | ${moment(fromDate).format('yyyy MMM DD hh:mm a')} - ${moment(toDate).format('yyyy MMM DD hh:mm a')}`}
        titleTag="h6"
        className="border-200 border-bottom py-2"
        endEl={<CardDropdown />}
      />
      {/* {JSON.stringify(tableData)} */}
      <Card.Body className="p-3 d-flex aligm-items-center">
         <SummaryPieChartAsset pieData={tableData} />
      </Card.Body>

    </Card>
  );
};

export default SummaryPieAsset;
